import state from './projectState'
import mutations from './projectMutations'
import actions from './projectActions'

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
